<template>
  <div class="container gx-1">
    <div class="row dashboard-border">
      <div class="col-md-12 col-12 align-self-center" >
        <img src="../../assets/icons/projects.png" height="32" width="32"/>
        <span class="mx-2"> {{project.projectName}} </span>
      </div>
    </div>
    <div class="row mt-3">
        <div class="col-12 text-end mb-2">
          <button class="btn" type="button"
                  style="background-color: #56759c;color:#ffffff;margin-right: 3px;" @click="openCloseRoleModal()"
                  data-bs-toggle="modal" data-bs-target="#deneme">
            <font-awesome-icon icon="plus"/>
            <span style="color: #ffffff;font-weight: unset" class="px-1">Add Role</span>
          </button>
        </div>

        <div class="row table-responsive modified-table">
          <table class="table table-bordered table-hover table-font">
            <thead>
            <tr>
              <th>Resource</th>
              <th v-for="role in rolesOfProject" :key="role.id">
                {{role.roleName}}
              </th>
            </tr>
            </thead>
            <tbody style="vertical-align: middle">
            <tr style="width: 10%" v-for="permission in projectPermissions" :key="permission.id">
              <td style="width: 10%; font-weight: bold">{{permission.permissionName}}</td>
              <td v-for="role in rolesOfProject" :key="role.id">
                       <span v-if="role.id>0">
                              <button class="button perm-button" style="width: 50px" title="" :class="CheckPermissionForRole(role.id,permission.id)"
                                      @click="SetPermissionForRole(role.id,permission.id)">
                                <font-awesome-icon :icon="CheckPermissionForRoleIcon(role.id,permission.id)" size="sm"/>
                              </button>
                       </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
    </div>

    <add-role :projectId='selectedProjectId'
              :isActiveProjectRoleModal='isActiveProjectRoleModal'
              @openCloseRoleModal="openCloseRoleModal"
    />

    <!--
    <user-assign-project :project-id="selectedProjectId"
                         :isActiveUserModal="isActiveUserModal"
                         @openCloseUserModal="openCloseUserModal"
    />

    <add-permission
        :selected-role-id=0
        :project-id="parseInt(selectedProjectId)"
        :isActiveProjectUserPermissionModal="isActiveProjectUserPermissionModal"
        @openClosePermissionModal="openClosePermissionModal"
    />
-->
    <manage-role
        :project-id="selectedProjectId"
        :role-id=selectedRoleId
        :role-name="selectedRoleName"
        :is-active-manage-role-modal="isActiveManageRoleModal"
        @openCloseManageRoleModal="openCloseManageRoleModal"
    />
  </div>

</template>

<script>
import {mapState, mapActions} from "vuex"
import AddRole from "../../components/ui/AddRole";
//import UserAssignProject from "../../components/ui/UserAssignProject";
//import AddPermission from "../../components/ui/AddPermission";
import ManageRole from "../../components/ui/ManageRole";

export default {
  name: "ProjectDetails",
  components: {
    AddRole,
    //UserAssignProject,
    //AddPermission,
    ManageRole
  },
  data() {
    return {
      selectedProjectId: this.$route.params.selectedProjectId,
      selectedProjectName: this.$route.params.selectedProjectName,
      selectedProjectCode: this.$route.params.selectedProjectCode,
      selectedRoleId: 0,
      selectedRoleName: "",
      openUserAssignList: true,
      openRoleList: true,
      openUserRolelist: true,
      searchTextUser: "",
      searchTextUserRoleAssign: "",
      isActiveUserModal: false,
      isActiveProjectRoleModal: false,
      isActiveProjectUserRoleModal: false,
      isActiveProjectUserPermissionModal: false,
      isActiveManageRoleModal: false,
      selectedUsers: [],
      projectRoles: [],
      userForm: {
        userId: [],
        projectId: 0
      },
      setRolePermission: {
        roleId: 0,
        permissionId: 0,
        accessType: 'R'
      }
    }
  },

  methods: {
    ...mapActions('projects', ['getProjects', 'getProject', 'getUserProject', 'addUserProject', 'addProject', 'openCloseProjectModal', 'deleteUser']),
    ...mapActions('roles', ['getRoles', 'getRolesOfProject', 'addRole', 'deleteRole', 'getPermissions', 'getRolePermissions', 'addRolePermission', 'getPermissionsByProject']),

    async SetPermissionForRole(roleid, permid) {
      var result = this.rolePermissions.filter(x => x.roleId == roleid).filter(x => x.permissionId == permid)

      if (result.length > 0) {
        let accessType = result[0].accessType;
        if (accessType.trim() == 'R') {
          this.setRolePermission.accessType = 'W'
        } else {
          this.setRolePermission.accessType = 'N'
        }
      } else {
        this.setRolePermission.accessType = 'R';
      }

      this.setRolePermission.roleId = roleid;
      this.setRolePermission.permissionId = permid;

      try {
        await this.addRolePermission(this.setRolePermission);
        this.$notify({
          title: "Success",
          text: "Updated role permission successfully. ",
          type: "success"
        });
        await this.getRolePermissions(this.selectedProjectCode);
        await this.getPermissions()

      } catch (e) {
        this.$notify({
          title: "Error",
          text: "Failed to update role permission .." + e.message,
          type: "error"
        });
      }
    },

    CheckPermissionForRoleIcon(roleid, permid) {
      var result = this.rolePermissions.filter(x => x.roleId == roleid).filter(x => x.permissionId == permid)
      if (result.length > 0) {
        let accessType = result[0].accessType;
        if (accessType.trim() == "R") {
          return 'eye';
        } else {
          return 'edit';
        }
      } else {
        return 'times'
      }
    },

    CheckPermissionForRole(roleid, permid) {
      var result = this.rolePermissions.filter(x => x.roleId == roleid).filter(x => x.permissionId == permid)
      if (result.length > 0) {
        let accessType = result[0].accessType;
        if (accessType.trim() == "R") {
          return 'alert alert-warning';
        } else {
          return 'alert alert-success';
        }
      } else {
        return 'alert alert-danger'
      }
    },

    toggleDivUsers() {
      this.openUserAssignList = !this.openUserAssignList;
    },

    toggleDivRoles() {
      this.openRoleList = !this.openRoleList;
      console.log(this.selectedProjectId);
      const id = this.selectedProjectId;
      console.log(id);

      this.projectRoles = this.roles.filter(function (role) {
        return role.projectId === id;
      })

    },

    toggleDivUserRoles() {
      this.openUserRolelist = !this.openUserRolelist;
    },

    async openCloseRoleModal() {
      this.isActiveProjectRoleModal = !this.isActiveProjectRoleModal;
    },

    async openCloseUserModal() {
      this.isActiveUserModal = !this.isActiveUserModal;
      this.selectedUsers = [];
    },

    async openCloseUserRoleModal() {
      this.isActiveProjectUserRoleModal = !this.isActiveProjectUserRoleModal;
    },

    async openClosePermissionModal() {
      this.isActiveProjectUserPermissionModal = !this.isActiveProjectUserPermissionModal
      if (!this.isActiveProjectUserPermissionModal) {
        this.getRolePermissions(this.selectedRoleId);
        this.getPermissionsByProject(this.selectedProjectId);
      }
    },

    async openCloseManageRoleModal() {
      this.isActiveManageRoleModal = !this.isActiveManageRoleModal;
      if (!this.isActiveManageRoleModal) {
        this.getRolePermissions(this.selectedRoleId);
        this.getPermissionsByProject(this.selectedProjectId);
      }
    },

    async TryManageRoleModal(value, name) {
      this.selectedRoleId = value;
      this.selectedRoleName = name;
      this.openCloseManageRoleModal();
    },

    async TryDeleteUserProject(id, projectName) {
      await this.$swal({
        title: '<p style="font-size: 22px; font-family: ui-sans-serif;text-align: center">You are about to remove "' + projectName + '"  from this project. Are you sure?</p>',
        html: "",
        showCancelButton: true,
        cancelButtonText: 'No',
        cancelButtonColor: '#ec2929d4',
        confirmButtonColor: '#1e3e67',
        confirmButtonText: 'Yes',
      }).then(async (response) => {
        if (response.value) {
          try {
            await this.deleteUser(id);
            await this.getUserProject(this.selectedProjectId);
            this.$notify({
              title: "Success",
              text: "User deleted successfully. ",
              type: "success"
            });

          } catch (e) {
            this.$notify({
              title: "Error",
              text: "Failed to delete user.." + e.message,
              type: "error"
            });
          }
        }
      });
    },

    async TryDeleteProjectRole(id, name) {
      await this.$swal({
        title: '<p style="font-size: 22px; font-family: ui-sans-serif;text-align: center">You are about to remove "' + name + '"  from this project. Are you sure?</p>',
        html: "",
        showCancelButton: true,
        cancelButtonText: 'No',
        cancelButtonColor: '#ec2929d4',
        confirmButtonColor: '#1e3e67',
        confirmButtonText: 'Yes',
      }).then(async (response) => {
        if (response.value) {
          try {
            await this.deleteRole(id);
            await this.getRolesOfProject(this.selectedProjectId);
            this.$notify({
              title: "Success",
              text: "Role deleted successfully. ",
              type: "success"
            });

          } catch (e) {
            this.$notify({
              title: "Error",
              text: "Failed to delete role.." + e.message,
              type: "error"
            });
          }
        }
      });
    },
  },

  computed: {
    ...mapState('projects', ['projects', 'project', 'userProject', 'isActiveProjectModal']),
    ...mapState('roles', ['roles', 'rolesOfProject', 'rolePermissions', 'permissions', 'projectPermissions']),

    searchProjectUsers: function () {
      return this.userProject.filter((post) => {
        return post.userName.toUpperCase().match(this.searchTextUser.toUpperCase());
      }).sort((a, b) => (a.createDT < b.createDT) ? 1 : -1)
    },


  },

  async created() {
    await this.getProject(this.selectedProjectId);
    //await this.getUserProject(this.selectedProjectId);
    //await this.getRolesOfProject(this.selectedProjectId);
    await this.getRolePermissions(this.selectedProjectCode);
    await this.getPermissionsByProject (this.selectedProjectId);

  }
}
</script>

<style scoped>

  .media-content {
    margin: auto;
  }

  .delete-role {
    margin-left: 5px;
    cursor: pointer;
  }
  .delete-role:hover {
    box-shadow: 0 0.5em 0.5em -0.4em;
    transform: translateY(-0.25em);
  }

  .perm-button:hover {
    box-shadow: rgba(3, 102, 214, 0.3) 0px 0px 0px 3px;
  }
  .perm-button{
    width: 35px !important;
    height: 30px;
    padding: 0px;
  }
  .table-font{
    border-left: 1px solid #dfe0e1;
    border-right: 1px solid #dfe0e1;
  }
  .perm-style{
    font-weight: 550;
    font-size: 15px;
    cursor: pointer;
    color: #5670cc;
    font-family: Helvetica, Arial;
    text-decoration: unset;
  }

</style>
